import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { ConsumptionBasedScopeOne } from "../../../../api/supplier-questionnaire/tabs";

export const consumptionBasedScopeOneKeys = {
  items: () => ["consumptionBasedDirectEmissionsItems"]
};

export function useGetConsumptionBasedDirectEmissionsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery([...consumptionBasedScopeOneKeys.items(), params.type, params.queryParams.page],
    () => callApi(ConsumptionBasedScopeOne.getConsumptionBasedDirectEmissionsItems, params), config);
}

export function useAddConsumptionBasedDirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data, type }) =>
    callApi(ConsumptionBasedScopeOne.addConsumptionBasedDirectEmissionsItem, { questionnaireId, data, type }), config);
}

export function useUpdateConsumptionBasedDirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data, type }) =>
    callApi(ConsumptionBasedScopeOne.updateConsumptionBasedDirectEmissionsItem, {
      questionnaireId,
      recordId,
      data,
      type
    }), config);
}

export function useDeleteConsumptionBasedDirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, type }) =>
    callApi(ConsumptionBasedScopeOne.deleteConsumptionBasedDirectEmissionsItem, {
      questionnaireId,
      recordId,
      type
    }), config);
}